import { ProcessAnimation } from './ProcessAnimation'
export default ProcessAnimation
